import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  Title,
  type ChartEvent,
  type ActiveElement,
  type ChartOptions,
  Filler,
} from 'chart.js';
import isArray from 'lodash-es/isArray';
import { Pie } from 'react-chartjs-2';
import { ErrorBoundary, ChartErrorFallback } from 'Components/ErrorBoundary';
import classes from './AvailabilityChart.module.scss';

ChartJS.register(ArcElement, Tooltip, Legend, Title, Filler);

interface AvailabilityChartProps {
  lifts: {
    bracket: LiftStatus.Schemas.IStatsBracketDto[];
  };
  intercom: {
    bracket: LiftStatus.Schemas.IStatsBracketDto[];
  };
  showDetails?: (type: string, dataSet: (number | null)[]) => void;
}

const AvailabilityChart = (props: AvailabilityChartProps) => {
  const { lifts, intercom } = props;
  const labels = ['0% tot 98%', '98% tot 99%', '99 tot 100%'];
  const getChartOptions = (
    title: string,
    type: 'lifts' | 'loudspeaker'
  ): ChartOptions<'pie'> => ({
    responsive: true,
    maintainAspectRatio: false,
    resizeDelay: 200,
    animation: false,
    plugins: {
      title: {
        display: true,
        text: title,
      },
    },
    onClick: (event: ChartEvent, elements: ActiveElement[]) => {
      if (elements.length > 0) {
        const dataSetIndex = elements[0]?.index;
        const dataSet: (number | null)[] = [];

        if (dataSetIndex === 0) {
          dataSet.push(0, 0.98);
        } else if (dataSetIndex === 1) {
          dataSet.push(0.98, 0.99);
        } else {
          dataSet.push(0.99, null);
        }

        if (props.showDetails) {
          props.showDetails(type, dataSet);
        }
      }
    },
  });

  const availabilityData = {
    labels,
    datasets: [
      {
        label: 'Liften',
        data: isArray(lifts?.bracket)
          ? lifts.bracket.map((bracket) => bracket.count)
          : [],
        fill: true,
        backgroundColor: ['#F3776D', '#F3C46D', '#86B29C'],
        borderColor: 'white',
      },
    ],
  };

  const loudSpeakerData = {
    labels,
    datasets: [
      {
        label: 'Spreekluister',
        data: isArray(intercom?.bracket)
          ? intercom.bracket.map((bracket) => bracket.count)
          : [],
        fill: true,
        backgroundColor: ['#F3776D', '#F3C46D', '#86B29C'],
        borderColor: 'white',
      },
    ],
  };

  return (
    <div className={classes.root}>
      <div className={classes.leftGraph}>
        <ErrorBoundary
          level="component"
          fallback={<ChartErrorFallback title="Liften Chart Error" />}
        >
          <div className={classes.chartFrame}>
            <Pie
              data={availabilityData}
              options={getChartOptions('Liften', 'lifts')}
            />
          </div>
        </ErrorBoundary>
      </div>
      <div className={classes.rightGraph}>
        <ErrorBoundary
          level="component"
          fallback={<ChartErrorFallback title="Spreekluister Chart Error" />}
        >
          <div className={classes.chartFrame}>
            <Pie
              data={loudSpeakerData}
              options={getChartOptions('Spreekluister', 'loudspeaker')}
            />
          </div>
        </ErrorBoundary>
      </div>
    </div>
  );
};

export default AvailabilityChart;
